import { render } from "./CfmArmsReport.vue?vue&type=template&id=596d9700&scoped=true&ts=true"
import script from "./CfmArmsReport.vue?vue&type=script&lang=ts"
export * from "./CfmArmsReport.vue?vue&type=script&lang=ts"

import "./CfmArmsReport.vue?vue&type=style&index=0&id=596d9700&scoped=true&lang=css"
import "./CfmArmsReport.vue?vue&type=style&index=1&id=596d9700&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596d9700"]])

export default __exports__